import { createApp } from 'vue';
import { createAgonI18n } from '../../i18n';
import StyleList from './StyleList.vue';

declare const rootProps: never;

const i18n = createAgonI18n(rootProps['culture']);

createApp(StyleList, rootProps).use(i18n).mount('#style-list');
